import styled from "styled-components";
export const TaskContainer = styled.section`
  z-index: 100;
  position: absolute;
  height: 38px;
  top: 5px;

  cursor: pointer;
  border-radius: 8.5px;

  display: flex;
  align-items: center;
  text-overflow: ellipsis;

  div {
    &.arrow_cond {
      cursor: auto;
      pointer-events: none;
      z-index: -500;
      path {
        stroke-dasharray: 3;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  border-radius: 8.5px;

  border: ${({ status }) =>
    status === "doneLate" ? "2px solid #D93333" : "2px solid transparent"};

  background-color: ${({ status }) =>
    status === "done"
      ? "#49B446"
      : status === "late"
        ? "#D93333"
        : status === "doing"
          ? "#EACB29"
          : status === "pending"
            ? "#D4D6DA"
            : "#49b446"};

  span {
    margin-left: 10px;
    color: ${({ status }) =>
    (status === "done") | (status === "late") | (status === "doneLate")
      ? "#fff"
      : "#212326"};
    font-weight: 600;

    
    white-space: nowrap;       /* Prevent text from wrapping */
    overflow: hidden;          /* Hide any overflowing content */
    text-overflow: ellipsis;   /* Display "xx..." when text overflows */


  }
`;

export const Avatar = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;

export const Anchor = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 100%;
  margin-left: 10px;
`;
